export const SITE_NAME = 'Date.Mut.Vn';
export const SITE_DOMAIN_LABEL = 'date.mut.vn';
export const SITE_URL = 'http://date.mut.vn';
export const QUIZ_URL = `${SITE_URL}/quiz`;
export const QUIZ_PATH_LABEL = 'date.mut.vn/quiz';